<template>
    <div>
        <!-- @input="closeSnackbar"  -->
        <v-snackbar v-model="snackbarData" @input="closeSnackbar" top right color="success" :timeout="2000">
            <v-layout align-center pr-4>
                <v-icon class="pr-3" dark large>mdi-check-circle</v-icon>
                <v-layout column>
                    <div>
                        <strong>INFORMACION: </strong>
                    </div>
                    <div>{{ mensajeAlertaData }}</div>
                </v-layout>
            </v-layout>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: 'alertaMensaje',
    props: {
        snackbar: { 
            type: Boolean, 
            default: false  
        },
        mensajeAlertaData: { 
            type: String, 
            default: "" 
        }
        // tiempoDuracionData: Number,
        // mensajeAlertaData: String
    },
    components: {},
    data: () => ({
        snackbarData: false,
        snackbarDatanewVal: false
    }),
    methods: {
        closeSnackbar(snackbar) {
            this.$emit('update-snackbar', snackbar);
            // console.log(snackbar);
        }
    },
    watch:{
        snackbar: function(e) {
            // console.log(newVal)
            // oldVal;
          this.snackbarData=e;
        }
    }
}
</script>

<style></style>